export enum LocalStorageKeyNames {
    token = 'token',
    userGroup = 'ug',
}
